"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/trips.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var directives_1 = require("./directives");
var filters_1 = require("./filters");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module profumo.apps.trips
 * @name profumo.apps.trips
 * @packageName profumo.apps
 * @description A module that includes the dashboard component.
 */
angular.module('profumo.apps.trips', ['ui.router'])
    .controller('TripsListController', controllers_1.TripsListController)
    .controller('TripsEditController', controllers_1.TripsEditController)
    .directive('routeMap', directives_1.RouteMapDirective)
    .directive('locationMap', directives_1.LocateMapDirective)
    .service('_trip', services_1.TripService)
    .filter('speed', filters_1.SpeedFilter)
    .filter('bearing', filters_1.BearingFilter)
    .filter('distance', filters_1.DistanceFilter)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/index.ts
// module id = 558
// module chunks = 0